// --- Common error messages ---------------------------------------------------
export const COP_COMMON_ERROR_MESSAGES = {
  "api-error": {
    "message": "An unexpected issue occurred while {{action}}, please contact system administrator.",
    "action": {
      "site-assets-tree-view-loading": "obtaining site assets tree view",
      "export-failed": "Issue occurred while generating {{exportType}}.",
      "agreement-details-loading": "obtaining agreement details",
      "agreements-loading": "obtaining agreements",
      "assets-loading": "obtaining assets",
      "asset-details-loading": "obtaining asset details",
      "case-details-loading": "obtaining case details",
      "case-comments-loading": "obtaining case comments",
      "case-approval": "approving the case",
      "case-rejection": "rejecting the case",
      "contacts-loading": "obtaining contact details",
      "home-page-card-parsing": "processing home page card configuration",
      "home-page-count-loading": "obtaining home page count data",
      "site-details-loading": "obtaining site details",
      "regions-loading": "obtaining regions",
      "sites-for-region-loading": "obtaining sites for selected region",
      "regions-and-sites-loading": "obtaining regions and sites",
      "user-account-loading": "obtaining user accounts",
      "user-account-selection-submitting": "submitting account selection",
      "assets-search-loading": "obtaining product catalog assets",
      "sites-exporting": "exporting sites list",
      "users-loading": "obtaining users",
      "users-exporting": "exporting users",
      "user-deletion": "deleting user",
      "current-user-loading": "obtaining current user",
      "subscriptions-loading": "obtaining subscriptions",
      "subscription-deletion": "deleting subscription",
      "sites-loading": "obtaining sites",
      "agreements-by-site-loading": "obtaining agreements by site",
      "notifications-unread-count-loading": "obtaining unread notification count",
      "notifications-mark-all-read": "marking all notifications as read",
      "notifications-mark-read": "marking notification as read",
      "notifications-loading": "obtaining notifications",
      "signalr-negotiation": "negotiating real-time notifications",
      "case-accepting": "accepting case",
      "case-rejecting": "rejecting case",
      "http-request-processing": "processing API request",
      "assets-by-category-loading": "obtaining assets by product category",
      "assets-exporting": "exporting assets",
      "cases-loading": "obtaining cases",
      "world-map-config-loading": "obtaining map configuration",
      "notification-settings-saving": "saving notification settings",
      "notification-settings-loading": "obtaining notification settings",
      "token-auth-user-redirect": "redirecting user based on account role"
    }
  }
} as const

export function getErrorMessage(actionKey: keyof typeof COP_COMMON_ERROR_MESSAGES['api-error']['action']): string {
  return COP_COMMON_ERROR_MESSAGES['api-error'].message.replace(
    '{{action}}',
    COP_COMMON_ERROR_MESSAGES['api-error'].action[actionKey],
  )
}
